import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';
import { getToggleAllDayState } from 'clevertap/hourFilter';

export function reportsShiftsStart({ outletIds, startDate, endDate }) {
  pushClevertapEvent('Report Shifts Start', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function reportsShiftsSelect({ shift }) {
  pushClevertapEvent('Report Shift Select', {
    'Current Selected Outlet': shift.outlet_id,
    'Toggle All Day': getToggleAllDayState(shift.end_date),
    'Current Time Filter Start': formatDate(shift.start_date),
    'Current Time Filter End': formatDate(shift.end_date),
    Name: shift.employee_name,
    'Starting Shift': formatDate(shift.created_at),
    'Ending Shift': formatDate(shift.ended_at) || '',
    'Starting Cash': shift.starting_cash,
    'Cash Sales': shift.cash_sales,
    'Cash from Invoice': shift.cash_invoice,
    'Cash Refunds': shift.cash_refund,
    'Total Expense': shift.total_expense,
    'Total Income': shift.total_income,
    'Expected Ending Cash': shift.expected_ending_cash,
    'Actual Ending Cash': shift.actual_ending_cash,
    'Debit Credit': shift.total_debit_credit,
    'Debit Credit Voided': shift.total_voided,
    'Expected Card Payment': shift.expected_card_payment,
    EDC: shift.total_edc,
    'Gift Card': shift.total_gift_card,
    Other: shift.total_other,
    'Other Refunds': shift.other_refunds,
    'Expected Other Payment': shift.expected_other_payment,
    'Total Expected': shift.total_expected,
    'Total Actual': shift.total_actual,
    Difference: shift.total_difference,
  });
}
